var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"showcase-revamp"}},[(_vm.isPlayground)?_c('div',{staticClass:"showcase-action-header"},[_c('span',{staticClass:"material-icons arrow_back",on:{"click":_vm.onGoBack}},[_vm._v("arrow_back")])]):_vm._e(),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }